import React, { useEffect, useState } from 'react';
import axios from "axios";
import moment from "moment";
import { Card, Table, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const renderStatusBadge = (status, t) => {
  const statusKey = status?.toLowerCase?.();

  const variant =
    {
      draft: "primary",
      active: "info",
      paused: "danger",
      completed: "success",
    }[statusKey] || "secondary";

  return (
    <span className="fw-medium font-size-13">
      <span className={`badge badge-subtle bg-${variant} px-3 py-1`}>
        <span>{t(statusKey) || status}</span>
      </span>
    </span>
  );
};

const OrderHistoryTableRow = ({ data, t }) => {
  const dummyRating = 0;

  return (
    <tr className="align-middle">
      <td className="text-nowrap">
        <span className="fw-normal font-size-12">
          {moment(data.StartDate).format("MMM DD, YYYY")}
        </span>
      </td>

      <td className="text-nowrap">
        <span className="fw-normal font-size-12">
          {data.Proposal?.TemplateName || "-"}
        </span>
      </td>

      <td className="text-nowrap">
        {renderStatusBadge(data.Status, t)}
      </td>

      <td>
        <span className="fw-medium font-size-13">
          {[...Array(5)].map((_, i) => {
            const isCompleted =
              data.Status?.toLowerCase() === "completed";

            return (
              <FontAwesomeIcon
                key={i}
                icon={faStar}
                className={`me-1 ${isCompleted && i < dummyRating
                  ? "text-warning"
                  : "text-300"
                  }`}
              />
            );
          })}
        </span>
      </td>

      <td className="text-end">
        <a className="text-700 text-decoration-none d-inline-flex align-items-center rounded px-2 py-1 fw-medium font-size-13">
          {t("orderHistoryViewDetails")}
          <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-2 fs--2" />
        </a>
      </td>
    </tr>
  );
};

// Main Component
const OrderHistory = ({ relationId }) => {

  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!relationId) return;
    fetchOrders();
  }, [relationId]);

  const fetchOrders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/ordersByRelation/${relationId}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );

      setOrders(res.data);

    } catch (err) {
      console.error("Error fetching order history:", err);
    }
  };

  return (
    <Card className="shadow-none rounded-3 overflow-hidden border">
      <Card.Body className="p-0">
        <Table responsive size="sm" className="fs-10 mb-0">
          <thead className="bg-100">
            <tr>
              <th className="fw-semibold font-size-13">
                {t("OrderDate")}
              </th>
              <th className="fw-semibold font-size-13">
                {t("orderHistoryType")}
              </th>
              <th className="fw-semibold font-size-13">
                {t("orderHistoryStatus")}
              </th>
              <th className="fw-semibold font-size-13">
                {t("orderHistoryRating")}
              </th>
              <th className="text-end fw-semibold font-size-13">
                {t("orderHistoryActions")}
              </th>
            </tr>
          </thead>

          <tbody>
            {orders.length > 0 ? (
              orders.map((order, index) => (
                <OrderHistoryTableRow
                  data={order}
                  t={t}
                  key={order.OrderId || index}
                />
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-5 text-muted fs-9">
                  {t("orderHistoryNoOrdersFound")}
                </td>
              </tr>
            )}
          </tbody>

        </Table>
      </Card.Body>
    </Card>
  );
};

export default OrderHistory;